const EVENT_PREFIX = 'forge.bridge.';
export function on(event, callback, extension) {
  const wrappedCallback = e => {
    var _e$detail, _e$detail2, _e$detail2$extension, _e$detail3, _e$detail3$extension;
    if (!extension || !((_e$detail = e.detail) !== null && _e$detail !== void 0 && _e$detail.extension) || extension.id === ((_e$detail2 = e.detail) === null || _e$detail2 === void 0 ? void 0 : (_e$detail2$extension = _e$detail2.extension) === null || _e$detail2$extension === void 0 ? void 0 : _e$detail2$extension.id) && extension.installationId === ((_e$detail3 = e.detail) === null || _e$detail3 === void 0 ? void 0 : (_e$detail3$extension = _e$detail3.extension) === null || _e$detail3$extension === void 0 ? void 0 : _e$detail3$extension.installationId)) {
      var _e$detail4, _e$detail5;
      callback((_e$detail4 = e.detail) === null || _e$detail4 === void 0 ? void 0 : _e$detail4.payload, (_e$detail5 = e.detail) === null || _e$detail5 === void 0 ? void 0 : _e$detail5.extension);
    }
  };
  window.document.addEventListener(`${EVENT_PREFIX}${event}`, wrappedCallback);
  return {
    unsubscribe: () => window.document.removeEventListener(`${EVENT_PREFIX}${event}`, wrappedCallback)
  };
}
export function emit(event, payload, extension) {
  const newEvent = new CustomEvent(`${EVENT_PREFIX}${event}`, {
    detail: {
      extension,
      payload
    }
  });
  window.document.dispatchEvent(newEvent);
}